/**
 * This file contains many functions that make calls to our API and return the promises from those calls.
 */
import Api from '../api.ts';

const ADMIN = '/admin';

const AdminAPI = {
  /**
   * Gets the global record
   *
   * @param data
   * @returns {promise} Promise returned from the API call eventually
   * promises a global object.
   */
  getGlobal() {
    return Api.get(`${ADMIN}/global`);
  },

  /**
   * Updates the global record
   *
   * @param data
   * @returns {promise} Promise returned from the API call eventually
   * promises an updated global object.
   */
  updateGlobal(data) {
    return Api.put(`${ADMIN}/global`, { data });
  },
};

export default AdminAPI;
